/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import subDays from 'date-fns/sub_days';
import subHours from 'date-fns/sub_hours';
import addMinutes from 'date-fns/add_minutes';
import addHours from 'date-fns/add_hours';
import addDays from 'date-fns/add_days';
import startOfDay from 'date-fns/start_of_day';
import startOfHour from 'date-fns/start_of_hour';
import endOfHour from 'date-fns/end_of_hour';
import endOfDay from 'date-fns/end_of_day';
import format from 'date-fns/format';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Row,
  Col,
  Panel,
} from 'react-bootstrap';
import Refresher from 'loracoms/Refresher';
import InlineSelect from 'loracoms/InlineSelect';
import Toolbar from 'loracoms/Toolbar';
import ShowIf from 'loracoms/ShowIf';
import CollapseToggle from 'loracoms/CollapseToggle';
import DatePicker from 'loracoms/DatePicker';
import IntlMsg from 'lorautils/intl/IntlMsg';
import gatewayActions from 'loraactions/gateway';
import GatewayTOAUplinkTrend from '../GatewayTOAUplinkTrend';
import GatewayTOARatioUplinkTrend from '../GatewayTOARatioUplinkTrend';
import GatewayTOAUplinkPie from '../GatewayTOAUplinkPie';
import styles from './styles.scss';


const kUnitDuration = {
  YYYYMMDDHHmm: 600000,
  YYYYMMDDHH: 3600000,
  YYYYMMDD: 86400000,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  getGatewayTOAStats: React.PropTypes.func.isRequired,
  toaStats: React.PropTypes.object.isRequired,
};

class GatewayTOAStat extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  static addOne(t, by) {
    switch (by) {
      case 'YYYYMMDDHHmm': return addMinutes(t, 1);
      case 'YYYYMMDDHH': return addHours(t, 1);
      case 'YYYYMMDD': return addDays(t, 1);
      default: return t;
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      toaStats: props.toaStats,
      by: 'YYYYMMDDHHmm',
      dataView: 'ratio',
    };
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.handleReload = this.handleReload.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statview');
  }

  componentWillMount() {
    this.loadTOA();
  }

  componentWillReceiveProps(nextProps) {
    const { toaStats } = nextProps;
    if (toaStats !== this.props.toaStats) {
      this.setState({ toaStats });
    }
  }

  defaultFrom(by = this.state.by) {
    switch (by) {
      case 'YYYYMMDDHHmm':
        return startOfHour(subHours(new Date(), 6));
      case 'YYYYMMDDHH':
        return startOfHour(subHours(new Date(), 24));
      case 'YYYYMMDD':
        return startOfDay(subDays(new Date(), 7));
      default:
        return startOfHour(subHours(new Date(), 24));
    }
  }

  defaultTo(by = this.state.by) {
    switch (by) {
      case 'YYYYMMDDHHmm':
      case 'YYYYMMDDHH':
        return endOfHour(new Date());
      case 'YYYYMMDD':
        return endOfDay(new Date());
      default:
        return endOfHour(new Date());
    }
  }

  loadTOA(args = {}) {
    const { getGatewayTOAStats } = this.props;
    const { gatewayId } = this.props;
    const {
      by = this.state.by,
      from = this.state.from || this.defaultFrom(by),
    } = args;
    let {
      to = this.state.to || this.defaultTo(by),
    } = args;
    to = GatewayTOAStat.addOne(to, by);
    getGatewayTOAStats(gatewayId, {
      from: format(from, by),
      to: format(to, by),
    });
  }

  handleChangeFrom(from) {
    const to = endOfDay(from);
    const sod = startOfDay(from);
    this.setState({ from: sod, to });
    this.loadTOA({ from: sod, to });
  }

  handleChangeTo(to) {
    const eod = endOfDay(to);
    this.setState({ to: eod });
    this.loadTOA({ to: eod });
  }

  handleChangeBy(by) {
    this.setState({ by });
    this.loadTOA({ by });
  }

  handleChangeDataView(dataView) {
    this.setState({ dataView });
  }

  handleReload() {
    this.loadTOA();
  }

  renderTOAStats() {
    const {
      toaStats: { status },
      by,
      dataView,
      expanded = true,
      resize = 0,
    } = this.state;
    const header = (
      <div>
        <span>{this.intlMsg.msg('toastat.byfreq.uplink')}</span>
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.handleReload}
              reloading={status === 'pending'}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={(v) => { this.setState({ expanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={expanded}
        onEntered={() => { this.setState({ resize: Math.random() }); }}
      >
        <Row>
          <Col md={9} className="collapse-right">
            <ShowIf if={dataView === 'ratio'}>
              <GatewayTOARatioUplinkTrend
                unitDuration={kUnitDuration[by]}
                resize={resize}
              />
            </ShowIf>
            <ShowIf if={dataView === 'ms'}>
              <GatewayTOAUplinkTrend resize={resize} />
            </ShowIf>
          </Col>
          <Col md={3} className="collapse-left">
            <GatewayTOAUplinkPie resize={resize} />
          </Col>
        </Row>
      </Panel>
    );
  }

  renderToolbar() {
    const {
      by,
      dataView,
      from = this.defaultFrom(by),
      to = this.defaultTo(by),
    } = this.state;
    const icon = <span className="halflings halflings-filter" />;
    const leftTools = [{
      input: <DatePicker date={from} onSelect={this.handleChangeFrom} />,
    }, {
      input: (
        <DatePicker
          date={to}
          onSelect={this.handleChangeTo}
          disabled={d => GatewayTOAStat.handleDisableDate(d, from)}
        />
      ),
    }, {
      input: (
        <InlineSelect
          bsStyle="aisz-primary"
          options={[{
            label: this.intlMsg.msg('toolbar.bytime.minutes'),
            value: 'YYYYMMDDHHmm',
            active: true,
          }, {
            label: this.intlMsg.msg('toolbar.bytime.hours'),
            value: 'YYYYMMDDHH',
          }, {
            label: this.intlMsg.msg('toolbar.bytime.days'),
            value: 'YYYYMMDD',
          }]}
          values={[by]}
          onChange={selected => this.handleChangeBy(selected[0])}
        />
      ),
    }, {
      input: (
        <InlineSelect
          bsStyle="aisz-primary"
          options={[{
            label: this.intlMsg.msg('toolbar.dataview.ratio'),
            value: 'ratio',
            active: true,
          }, {
            label: this.intlMsg.msg('toolbar.dataview.ms'),
            value: 'ms',
          }]}
          values={[dataView]}
          onChange={selected => this.handleChangeDataView(selected[0])}
        />
      ),
    }];

    return (
      <Toolbar brandIcon={icon} leftTools={leftTools} />
    );
  }

  render() {
    return (
      <div className={styles.ota}>
        {this.renderToolbar()}
        <ul className={styles.panels}>
          <li>{this.renderTOAStats()}</li>
        </ul>
      </div>
    );
  }
}

GatewayTOAStat.propTypes = propTypes;

const mapStateToProps = state => ({
  toaStats: state.gateway.getGatewayTOAStats,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getGatewayTOAStats: gatewayActions.getGatewayTOAStats,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GatewayTOAStat));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayTOAStat/index.jsx